// Getters
export const graficos = (state) => {
  return state.corretora.data || []
}
export const graficosLoading = (state) => {
  return state.corretora.loading
}
export const graficosLastUpdate = (state) => {
  return state.corretora.lastUpdate
}
